export const ReturnDivisioneEnum = {
  DEFECTIVE: '1',
  GOOD: '2',
};

export const ReturnDivision = [
  { label: '不良品', value: ReturnDivisioneEnum.DEFECTIVE },
  { label: '良品', value: ReturnDivisioneEnum.GOOD },
];
